import { useEffect, useRef, useState } from 'react';
import { TagType } from '../accessExpress.types';
import { usePopper } from 'react-popper';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import clsx from 'clsx';
import Loader from 'components/Loader/Loader';

export const AddToCartButton = ({
  isSelected,
  onAddToCart,
  tag,
  className,
  disabled,
  isLoading,
}: {
  isSelected: boolean;
  onAddToCart: (tag?: string) => void;
  tag?: TagType;
  className?: string;
  disabled: boolean;
  isLoading?: boolean;
}) => {
  const triggerEltRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  const handleEnter = () => setIsVisible(true);
  const handleLeave = () => setIsVisible(false);
  const popperEltRef = useRef<HTMLDivElement>(null);
  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (popperEltRef.current) {
      setPopperElement(popperEltRef.current);
    }
  }, [isVisible]);

  const { styles, attributes } = usePopper(
    triggerEltRef.current,
    popperElement,
    {
      placement: 'top',
      modifiers: [
        { name: 'offset', options: { offset: [0, 10] } },
        { name: 'flip', options: { fallbackPlacements: ['top-start'] } },
        {
          name: 'preventOverflow',
          options: { boundary: 'clippingParents' },
        },
      ],
    },
  );
  return (
    <>
      <div
        ref={triggerEltRef}
        onMouseEnter={disabled ? handleEnter : undefined}
        onMouseLeave={disabled ? handleLeave : undefined}
      >
        <GraniteButton
          variant="tertiary"
          size="medium"
          onClick={(e) => {
            e.stopPropagation();
            onAddToCart(tag);
          }}
          className={clsx(
            'flex w-full max-w-[256px] !cursor-pointer',
            tag && tag !== 'Best offer' && '!max-w-[158px]',
            className,
          )}
          disabled={disabled || isLoading}
        >
          {isSelected ? 'Added to cart!' : 'Add to cart'}
          {isLoading && <Loader height="h-5" width="w-5" />}
        </GraniteButton>
      </div>
      {isVisible && (
        <div ref={popperEltRef} style={styles.popper} {...attributes.popper}>
          <div className="z-50 max-w-[300px] rounded-lg bg-background-base-surface-0 p-5 text-content-base-default shadow-elevation3">
            <p className="mt-1 text-sm font-medium">
              You may only add two access circuits to each location&apos;s cart.
            </p>
          </div>
        </div>
      )}
    </>
  );
};
